<template>
  <div class="patrol-page">
    <div class="patrol-header">
      <div class="patrol-title">巡检中心</div>
    </div>
    <div class="container">
      <div class="left">
        <div class="date-list">
          <div v-for="(time, index) in times" :key="index" class="date-item">
            <div class="date-header" @click="toggleDateExpand(index)" :class="{ active: selectedTime === index }">
              <span>{{ time }}</span>
              <down-outlined v-if="!expandedDates[index]" />
              <up-outlined v-else />
            </div>
            <div class="car-list" v-if="expandedDates[index]">
              <div v-for="(car, carIndex) in getCarsByDate(index)" :key="carIndex" class="car-item"
                :class="{ 'car-item-selected': selectedCarId === car.id }">
                <div class="car-info" @click="selectCar(car)">
                  <car-outlined class="car-icon" />
                  <span>{{ car.id }}</span>
                </div>
                <div class="car-actions">
                  <a-tooltip title="查看">
                    <eye-outlined class="car-action-icon" @click="viewCarVideo(car)" />
                  </a-tooltip>
                  <a-tooltip title="上传">
                    <upload-outlined class="car-action-icon" @click="uploadCarVideo(car)" />
                  </a-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <CesiumViewer ref="cesium" @car-click="handleCarClick" />
      </div>
      <div class="right">
        <a-collapse v-model:activeKey="collapseKey" class="custom-collapse">
          <a-collapse-panel :key="index" :header="item.name" v-for="(item, index) of collapsSelect">
            <div class="item-container" v-for="(img, i) of item.imgs" :key="'img' + i" style="position: relative">
              <a-space>
                <div class="">{{ i + 1 }}、</div>
                <div class="item-image-container">
                  <img :src="img.img" class="img clickable-image" @click="showImgModal(img.img)" />
                </div>
                <div class="item-info">
                  <div class="item-source">来源: {{ img.from }}</div>
                  <div class="item-actions">
                    <a-tooltip>
                      <template #title>定位</template>
                      <environment-outlined class="action-icon location-icon" @click="onLocation(img.position)" />
                    </a-tooltip>
                    <a-tooltip>
                      <template #title>查看</template>
                      <eye-outlined class="action-icon view-icon" @click="showImgModal(img.img)" />
                    </a-tooltip>
                    <a-tooltip>
                      <template #title>详情</template>
                      <container-outlined class="action-icon detail-icon" @click="showDetail(img.id)" />
                    </a-tooltip>
                  </div>
                </div>
                <img
                  :src="img.type ? require('../../assets/image/deal-yes.png') : require('../../assets/image/deal-no.png')"
                  class="tip" />
              </a-space>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>

  <!-- 视频播放器 -->
  <VideoPlayer v-model:visible="videoVisible" :title="videoTitle" :videoUrl="videoUrl" @close="handleVideoClose" />

  <!-- 图片弹窗 -->
  <a-modal title="问题图片" ref="modalRef" v-model:visible="imgModalVisible" width="80%" :footer="null"
    @cancel="imgModalVisible = false" :zIndex="1200" class="image-modal">
    <div class="enlarged-image-container">
      <img :src="imgModal" class="enlarged-image" />
    </div>
  </a-modal>
</template>

<script>
import api from '@/request/api';
import CesiumViewer from './components/CesiumViewer.vue';
import VideoPlayer from './components/VideoPlayer.vue';
import {
  EnvironmentOutlined,
  EyeOutlined,
  ContainerOutlined,
  DownOutlined,
  UpOutlined,
  CarOutlined,
  UploadOutlined
} from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import * as Cesium from "cesium";

export default {
  name: "Patrol",
  components: {
    CesiumViewer,
    VideoPlayer,
    EnvironmentOutlined,
    EyeOutlined,
    ContainerOutlined,
    DownOutlined,
    UpOutlined,
    CarOutlined,
    UploadOutlined
  },
  data() {
    return {
      imgModalVisible: false,
      imgModal: "",
      selectedTime: null,
      expandedDates: {}, // 记录每个日期是否展开
      // 视频播放器相关数据
      videoVisible: false,
      videoTitle: '',
      videoUrl: '',
      selectedCarId: null, // 记录当前选中的车辆ID
      detectLoading: false, // 检测视频加载状态
      times: [
        '2025年05月01日',
        '2025年05月02日',
        '2025年05月03日',
        // 可以继续添加更多时间项
      ],
      // 每个日期对应的巡检车数据
      dateCarMap: {
        0: [
          {
            id: '1号巡检车',
            type: 'car',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/car1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              { timestamp: Date.now(), location: [121.602408, 30.024817] },
              { timestamp: Date.now() + 5000, location: [121.602577, 30.024965] },
              { timestamp: Date.now() + 15000, location: [121.602719, 30.024968] },
              { timestamp: Date.now() + 20000, location: [121.602909, 30.024951] },
              { timestamp: Date.now() + 25000, location: [121.60308, 30.024927] },
              { timestamp: Date.now() + 30000, location: [121.603045, 30.024717] }
            ]
          },
          {
            id: '2号巡检车',
            type: 'car',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/car1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              { timestamp: Date.now() + 22500, location: [121.601863, 30.025043] },
              { timestamp: Date.now() + 25000, location: [121.602095, 30.025061] },
              { timestamp: Date.now() + 30000, location: [121.602151, 30.024852] },
              { timestamp: Date.now() + 35000, location: [121.602365, 30.024796] },
              { timestamp: Date.now() + 40000, location: [121.602532, 30.024984] },
              { timestamp: Date.now() + 45000, location: [121.602565, 30.025291] }
            ]
          },
          {
            id: '1号人员巡检',
            type: 'person',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/person1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              { timestamp: Date.now(), location: [121.602473, 30.025015] },
              { timestamp: Date.now() + 25000, location: [121.602423, 30.025015] },
              { timestamp: Date.now() + 30000, location: [121.602345, 30.025037] },
              { timestamp: Date.now() + 35000, location: [121.602231, 30.025052] },
              { timestamp: Date.now() + 40000, location: [121.602115, 30.025061] },
              { timestamp: Date.now() + 45000, location: [121.601916, 30.025076] }
            ]
          }
        ],
        1: [
          {
            id: '3号巡检车',
            type: 'car',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/car1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              { timestamp: Date.now(), location: [121.6036718976099, 30.026334707832902] },
              { timestamp: Date.now() + 5000, location: [121.60366120220493, 30.026135616920797] },
              { timestamp: Date.now() + 15000, location: [121.60363981139517, 30.025973565882836] },
              { timestamp: Date.now() + 20000, location: [121.60361574673641, 30.025735118874366] },
              { timestamp: Date.now() + 25000, location: [121.60357296511677, 30.025510561458958] },
              { timestamp: Date.now() + 30000, location: [121.60354355275467, 30.025292948632796] },
              { timestamp: Date.now() + 35000, location: [121.60350077113691, 30.025042924795798] }
            ]
          }
        ],
        2: [
          {
            id: '4号巡检车',
            type: 'car',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/car1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              { timestamp: Date.now(), location: [121.60157017031725, 30.02621379648535] },
              { timestamp: Date.now() + 5000, location: [121.60153769121592, 30.026047417935914] },
              { timestamp: Date.now() + 15000, location: [121.6015160384805, 30.02589041256857] },
              { timestamp: Date.now() + 20000, location: [121.60147002641992, 30.025702943148644] },
              { timestamp: Date.now() + 25000, location: [121.60146190664375, 30.02546626249925] }
            ]
          },
        ]
      },
      collapseKey: [],
      collapsSelect: [
        {
          name: "垃圾堆放（5）", imgs: [
            {
              img: require("../../assets/image/1.png"),
              from: "人员巡检",
              position: [121.602408, 30.024817],
              type: 1,
            },
            {
              img: require("../../assets/image/2.png"),
              from: "巡检车",
              position: [121.602577, 30.024965],
              type: 1,
            }, {
              img: require("../../assets/image/3.png"),
              from: "巡检车",
              position: [121.602719, 30.024968],
            }, {
              img: require("../../assets/image/4.png"),
              from: "无人机",
              position: [121.602909, 30.024951],
              type: 1,
            }, {
              img: require("../../assets/image/5.png"),
              from: "公众举报",
              position: [121.60308, 30.024927],
            },
          ]
        },
        {
          name: "车辆违停（5）", imgs: [
            {
              img: require("../../assets/image/1.png"),
              from: "人员巡检",
              position: [121.602408, 30.024817],
            },
            {
              img: require("../../assets/image/2.png"),
              from: "巡检车",
              position: [121.602577, 30.024965],
            }, {
              img: require("../../assets/image/3.png"),
              from: "巡检车",
              position: [121.602719, 30.024968],
            }, {
              img: require("../../assets/image/4.png"),
              from: "无人机",
              position: [121.602909, 30.024951],
            }, {
              img: require("../../assets/image/5.png"),
              from: "公众举报",
              position: [121.60308, 30.024927],
            },
          ]
        },
        {
          name: "道路损坏（5）", imgs: [
            {
              img: require("../../assets/image/1.png"),
              from: "人员巡检",
              position: [121.602408, 30.024817],
            },
            {
              img: require("../../assets/image/2.png"),
              from: "巡检车",
              position: [121.602577, 30.024965],
            }, {
              img: require("../../assets/image/3.png"),
              from: "巡检车",
              position: [121.602719, 30.024968],
            }, {
              img: require("../../assets/image/4.png"),
              from: "无人机",
              position: [121.602909, 30.024951],
            }, {
              img: require("../../assets/image/5.png"),
              from: "公众举报",
              position: [121.60308, 30.024927],
            },
          ]
        },
      ]
    };
  },
  mounted() {
    this.currentPointEntity = null;       // 当前图标实体
    this.currentLineEntity = null;        // 当前虚线实体
  },
  methods: {
    // 切换日期展开/折叠状态
    toggleDateExpand(index) {
      this.selectedTime = index;
      // 在 Vue 3 中直接修改对象属性即可，不需要 $set
      this.expandedDates = {
        ...this.expandedDates,
        [index]: !this.expandedDates[index]
      };

      // 如果是展开状态，加载该日期的巡检车数据
      if (this.expandedDates[index]) {
        this.loadCarsByDate(index);
      }
    },

    // 获取指定日期的巡检车列表
    getCarsByDate(dateIndex) {
      return this.dateCarMap[dateIndex] || [];
    },

    // 加载指定日期的巡检车数据到Cesium地图
    loadCarsByDate(dateIndex) {
      const cars = this.getCarsByDate(dateIndex);
      if (cars && cars.length > 0) {
        // 获取CesiumViewer实例
        const cesiumViewer = this.$refs.cesium;
        if (cesiumViewer) {
          // 清除之前的车辆数据
          cesiumViewer.clearCars && cesiumViewer.clearCars();
          // 加载新的车辆数据
          cesiumViewer.drawCarsWithPaths && cesiumViewer.drawCarsWithPaths(cars);
        }
      }
    },

    // 选择特定车辆
    selectCar(car) {
      // 设置当前选中的车辆ID
      this.selectedCarId = car.id;

      // 触发与点击车辆相同的事件
      this.handleCarClick({
        id: car.id,
        videoUrl: car.videoUrl
      });

      // 可以添加定位到该车辆的逻辑
      const cesiumViewer = this.$refs.cesium;
      if (cesiumViewer && cesiumViewer.focusOnCar) {
        cesiumViewer.focusOnCar(car.id);
      }
    },

    showDetail() {
      this.$emitter.emit('open-event-detail');
    },
    showImgModal(img) {
      this.imgModal = img;
      this.imgModalVisible = true;
    },

    // 解析可能的多图片字符串（以逗号分隔）
    getImagesArray(imagesStr) {
      if (!imagesStr) return [];
      return imagesStr.split(',').filter(img => img.trim() !== '');
    },

    // 处理车辆点击事件
    handleCarClick(carData) {
      console.log('车辆点击:', carData);

      // 设置当前选中的车辆ID
      this.selectedCarId = carData.id;

      this.videoTitle = `${carData.id} 实时监控`;

      // 如果没有真实视频，可以使用示例视频
      this.videoUrl = carData.videoUrl || 'https://www.w3schools.com/html/mov_bbb.mp4';

      // 确保视频播放器显示
      console.log('设置视频播放器可见性:', true);
      this.videoVisible = true;
      console.log('视频播放器可见性设置后:', this.videoVisible);
    },

    // 处理视频关闭事件
    handleVideoClose() {
      console.log('视频已关闭');
      // 可以在这里执行其他操作
    },

    onLocation(position, baseHeight = 40) {

      const [lon, lat] = position;
      let viewer = this.$refs.cesium.getViewer()

      // 移除旧图标和线
      if (this.currentPointEntity) viewer.entities.remove(this.currentPointEntity);
      if (this.currentLineEntity) viewer.entities.remove(this.currentLineEntity);

      const bottomPosition = Cesium.Cartesian3.fromDegrees(lon, lat, 0);

      // 创建一个动态高度变量
      const startTime = Date.now();

      // 定义 position 的 CallbackProperty，实现上下浮动
      const animatedPosition = new Cesium.CallbackProperty(() => {
        const elapsed = (Date.now() - startTime) / 500; // 秒
        const offset = Math.sin(elapsed * 2) * 1; // 上下±1米浮动，频率可调
        const height = baseHeight + offset;
        return Cesium.Cartesian3.fromDegrees(lon, lat, height);
      }, false);

      // 添加图标（带律动）
      this.currentPointEntity = viewer.entities.add({
        position: animatedPosition,
        billboard: {
          image: require("./../../assets/image/point.png"), // 定位图标
          width: 32,
          height: 32,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM
        },
      });

      // 添加一条虚线连接"底部点"
      this.currentLineEntity = viewer.entities.add({
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            const cartographic = Cesium.Cartographic.fromCartesian(animatedPosition.getValue());
            const floating = Cesium.Cartesian3.fromDegrees(lon, lat, cartographic.height);
            return [floating, bottomPosition];
          }, false),
          width: 2,
          material: new Cesium.PolylineDashMaterialProperty({
            color: Cesium.Color.fromCssColorString("#008dff"),
            dashLength: 8
          })
        }
      });

      viewer.flyTo(this.currentPointEntity);
    },

    testVideoPlayer() {
      // 测试视频播放器
      console.log('测试视频播放器');
      this.videoTitle = '测试视频';
      this.videoUrl = 'https://www.w3schools.com/html/mov_bbb.mp4';
      console.log('设置视频播放器可见性:', true);
      this.videoVisible = true;
      console.log('视频播放器可见性设置后:', this.videoVisible);
    },

    viewCarVideo(car) {
      // 设置视频标题和URL
      this.videoTitle = `${car.id} 巡检记录`;
      this.videoUrl = car.videoUrl || 'https://www.w3schools.com/html/mov_bbb.mp4';

      // 显示视频播放器
      this.videoVisible = true;
    },

    uploadCarVideo(car) {
      // 创建一个隐藏的文件输入元素
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'video/*';
      fileInput.style.display = 'none';

      // 处理文件选择事件
      fileInput.addEventListener('change', async (event) => {
        const file = event.target.files[0];
        if (file) {
          // 创建一个临时URL以便预览
          const tempUrl = URL.createObjectURL(file);

          // 更新车辆的视频URL
          const dateIndex = this.selectedTime;
          const cars = this.getCarsByDate(dateIndex);
          const carIndex = cars.findIndex(c => c.id === car.id);

          if (carIndex !== -1) {
            this.dateCarMap[dateIndex][carIndex].videoUrl = tempUrl;
            
            // 添加loading状态
            this.detectLoading = true;
            
            // 创建加载提示
            const loadingKey = `loading_${Date.now()}`;
            message.loading({ content: '正在处理视频...', key: loadingKey, duration: 0 });
            
            try {
              // 等待API响应，无论需要多长时间
              const result = await api.detect.detect(file);
              
              // API成功返回后
              message.success({ content: `${car.id} 的视频已成功处理`, key: loadingKey, duration: 2 });
              
              // 预览新上传的视频
              this.viewCarVideo(this.dateCarMap[dateIndex][carIndex]);
              
              return result; // 如果需要使用返回值
            } catch (error) {
              // 处理错误情况
              message.error({ content: '视频处理失败: ' + (error.message || '未知错误'), key: loadingKey, duration: 3 });
              console.error('视频处理错误:', error);
            } finally {
              // 无论成功失败都会执行
              this.detectLoading = false;
            }
          }
        }
      });

      // 触发文件选择对话框
      document.body.appendChild(fileInput);
      fileInput.click();

      // 清理DOM
      setTimeout(() => {
        document.body.removeChild(fileInput);
      }, 100);
    },
  },
  unmounted() {
    if (this.handler) {
      this.handler.destroy();
    }
  }
}
</script>

<style scoped lang="scss">
.patrol-page {
  width: 100%;
  height: 100%;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
}

.patrol-header {
  height: 64px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .patrol-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1890ff;
  }

  .patrol-actions {
    display: flex;
    gap: 12px;
  }
}

.container {
  flex: 1;
  display: flex;
  flex-direction: row;
  background-color: #f0f2f5;
  height: calc(100% - 64px);
}

.left {
  width: 200px;
  height: 100%;
  overflow-y: auto;
  /* 允许滚动 */
  background-color: white;
  border-right: 1px solid #e8e8e8;
  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.date-list {
  width: 100%;
}

.date-item {
  margin-bottom: 8px;
  border-radius: 4px;
  overflow: hidden;
}

.date-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f5f5f5;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  &.active {
    background-color: rgba(0, 123, 255, 0.2);
    color: #1890ff;
    font-weight: 500;
  }
}

.car-list {
  background-color: #fafafa;
  padding: 4px 0;
}

.car-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  justify-content: space-between;

  &:hover {
    background-color: #f0f0f0;
  }

  .car-icon {
    margin-right: 8px;
    color: #1890ff;
  }
}

.car-item-selected {
  background-color: #e6f7ff;
  border-right: 3px solid #1890ff;

  .car-icon {
    color: #1890ff;
    font-weight: bold;
  }

  span {
    color: #1890ff;
    font-weight: 500;
  }
}

.car-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.car-actions {
  display: flex;
  gap: 8px;
}

.car-action-icon {
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.2);
    color: #1890ff;
  }
}

.right {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 100%;
  overflow: hidden;
  background-color: white;
  border-left: 1px solid #e8e8e8;
  // box-shadow: -2px 0 8px rgba(0, 0, 0, 0.09);
}

.right-header {
  padding: 16px;
  background: linear-gradient(to right, #1890ff, #36cfc9);
  color: white;
  margin-bottom: 0;

  h3 {
    margin: 0;
    color: white;
    font-weight: 500;
  }
}

.custom-collapse {
  background-color: white;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 10px;

  &::-webkit-scrollbar {
    width: 1px; // 垂直滚动条宽度
  }

  :deep(.ant-collapse-header) {
    font-weight: 500;
    color: #333;
    background-color: #f9f9f9;

    &:hover {
      background-color: #f0f0f0;
    }
  }

  :deep(.ant-collapse-content-box) {
    padding: 12px;
  }

  .item-container {
    margin-bottom: 12px;
    padding: 10px;
    border-radius: 4px;
    background-color: #fafafa;
    transition: all 0.3s;

    &:hover {
      background-color: #f0f0f0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .item-index {
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #1890ff;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
  }

  .item-image-container {
    width: 80px;
    height: 45px;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .clickable-image {
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      opacity: 0.8;
    }
  }

  .enlarged-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .enlarged-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
  }

  .tip {
    position: absolute;
    right: 0;
    top: 0;
    height: 48px;
    transform: rotate(90deg);
  }

  .item-info {
    flex: 1;
    padding-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .item-source {
    font-size: 13px;
    color: #666;
    margin-bottom: 5px;
  }

  .item-actions {
    display: flex;
    align-items: center;
  }

  .action-icon {
    margin-right: 12px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;

    &:hover {
      transform: scale(1.2);
    }
  }

  .location-icon {
    color: #1890ff;
  }

  .view-icon {
    color: #52c41a;
  }

  .detail-icon {
    color: #fa8c16;
  }
}

.main {
  display: flex;
  flex: 1;
  justify-content: center;
  /* 居中对齐图片 */
  align-items: center;
  /* 垂直居中 */
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
  background-color: #171e21b3;
}

.main img,
.right img {
  max-width: 100%;
  /* 确保图片不超出容器 */
  height: auto;
  /* 保持图片比例 */
}

/* 确保图片弹窗在最前面 */
:deep(.image-modal) {
  z-index: 1200 !important;
}
</style>